import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06be5850"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "fullScreenHeader",
  class: "fullScreenHeader p-2"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = ["src"]

import { APP_SETTINGS, SERVER_DATA } from '@/aux/app_configuration';
import { useRoute } from 'vue-router';
import { ref, watch } from 'vue';

// Set default page title

export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenHeader',
  setup(__props) {

_useCssVars(_ctx => ({
  "54a41b0b": (_unref(APP_SETTINGS)('NAV_HEADER_BG_COLOR') || 'black'),
  "7492d879": (_unref(APP_SETTINGS)('NAV_HEADER_TEXT_COLOR') || 'white')
}))

const page_title = ref('Page title');

// Set watcher to change page title in header
const _route = useRoute();

watch(
  () => _route?.meta?.title,
  () => {
    page_title.value =
      (_route?.meta?.short_title as string) +
      (APP_SETTINGS('BETA_VERSION') === 'true' ? ' (Beta version)' : '');
  },
  {
    immediate: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(page_title.value), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(APP_SETTINGS)('ATO_NAME')), 1),
      (`${_unref(SERVER_DATA).PUBLIC_FOLDER}/${_unref(APP_SETTINGS)('ATO_LOGO')}`)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: `${_unref(SERVER_DATA).PUBLIC_FOLDER}/${_unref(APP_SETTINGS)('ATO_LOGO')}`,
            style: {"max-height":"20px"},
            class: "mb-0"
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})